import { render, staticRenderFns } from "./OrderTab.vue?vue&type=template&id=46ede8a0&scoped=true&"
import script from "./OrderTab.vue?vue&type=script&lang=js&"
export * from "./OrderTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderTab.vue?vue&type=style&index=0&id=46ede8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ede8a0",
  null
  
)

export default component.exports